module.exports = __webpack_public_path__ + "static/design-guidelines-header@2x-3c426dc076e941d695093f1f1fb8f955.png";